module.exports = __webpack_public_path__ + "img/notes.74ba6336.svg";